import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Datetime from 'components/Datetime';
import { I18n } from 'react-redux-i18n';
import Cell from 'components/ListView/Cell';
import { NavLink } from 'react-router-dom';
import CopyToClipBoard from 'components/CopyToClipBoard';
import AuthFeature from 'components/AuthFeature';
import {
    AUTH_EDIT_FILTER,
} from 'constants/permission';
import { FILTER_DETAIL } from 'constants/routes';
import buildActualPath from 'helpers/build-actual-path';
import FilterResult from 'components/FilterShortcut/FilterResult';
import FilterPinStatus from './FilterPinStatus';


class ListRow extends Component {
    static propTypes = {
        columns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
        data: PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string,
            fleet_user_id: PropTypes.string,
            type: PropTypes.number,
            pin: PropTypes.bool,
            criteria: PropTypes.shape({}),
            description: PropTypes.string,
            update_time: PropTypes.string,
            has_permission: PropTypes.bool,
        }).isRequired,
    };

    renderField({ data, name, length, width }) {
        let el = null;
        switch (name) {
        case 'id':
            if (data.has_permission) {
                el = (
                    <CopyToClipBoard>
                        <AuthFeature
                            requiredList={ [AUTH_EDIT_FILTER] }
                            fallback={ () => data.id }
                        >
                            <NavLink to={ buildActualPath(FILTER_DETAIL, { filterId: data.id }) }>
                                { data.id }
                            </NavLink>
                        </AuthFeature>
                    </CopyToClipBoard>
                );
            }
            else {
                el = (
                    <AuthFeature
                        requiredList={ [AUTH_EDIT_FILTER] }
                        fallback={ () => data.id }
                    >
                        <span className="no-permission-filter-name">{ data.id }</span>
                    </AuthFeature>
                );
            }

            break;
        case 'type':
            el = I18n.t(`filters.features_map.${ data.type }`);
            break;
        case 'pin':
            el = (<FilterPinStatus pin={ data[name] } />);
            break;
        case 'result':
            const payload = data?.criteria ?? null;
            el = data.criteria && data.has_permission ? (<FilterResult
                type={ data.type }
                payload={ payload }
                context={ I18n.t('filters.link') }
                disabled={ !data.has_permission }
            />): '--';
            break;
        case 'update_time':
            el = (<Datetime time={ data[name] } />);
            break;
        case 'name':
        default:
            if (data.has_permission) {
                el = data[name]?? '--';
            }
            else {
                el = <span className="no-permission-filter-name">{ data[name]?? '--' }</span>
            }

            break;
        }

        return (
            <Cell
                key={ `${ data.id }-${ name }` }
                name={ name }
                style={ {
                    width,
                } }
            >
                { el }
            </Cell>
        );
    }

    render() {
        const { columns, data } = this.props;
        return columns.map(({ key, width }, i) => {
            return this.renderField({ data, width, name: key, length: columns.length });
        });
    }
}

export default ListRow;
